import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import formStyles from './RegistrationForm.scss';
import styles from './PatientRegistrationForm.scss';
import {
    Button,
    ButtonLink,
    Form,
    FormCheckbox,
    FormFieldWrapper,
    FormPhoneNumber,
    FormTextField,
    GenderDropDownList,
    InputFile,
    TimeWithTimezoneLabel,
    TimezoneDropDownList
} from 'components/controls';
import validatePatientFields from './validatePatientFields';
import DefaultAvatar from 'assets/forms/default-avatar.svg';
import moment from 'moment-timezone';
import _ from 'lodash';
import ErrorMessage from 'components/controls/form/ErrorMessage';
import FormDatePicker from 'components/controls/fields/FormDatePicker';


export default class PatientRegistrationForm extends PureComponent {
    static propTypes = {
        onScroll: PropTypes.func.isRequired,
        registrationError: PropTypes.any,
        registrationProcessing: PropTypes.bool,
        fieldValues: PropTypes.any,
        onFieldChange: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired
    };

    state = {
        avatar: null
    };

    render() {
        const {
            serverError,
            processing,
            fieldValues,
            onFieldChange,
            onSubmit,
            onScroll,
            fieldValues: {
                acceptPrivacyPolicy,
                acceptTerms,
                acceptPrescriptionPolicy
            }
        } = this.props;
        const {avatar} = this.state;

        return (
            <Form className={formStyles.form}
                fieldValues={fieldValues}
                clientValidate={validatePatientFields}
                serverError={serverError}
                processing={processing}
                onFieldChange={onFieldChange}
                onSubmit={onSubmit}
                ref='form'
                onScrollToTop={onScroll}
                scrollOnError
            >
                <div className={styles.avatarContainer}>
                    <div className={styles.avatar} style={{backgroundImage: `url(${avatar ? avatar : DefaultAvatar})`}}>
                        <ButtonLink className={styles.fileButton} onClick={() => this.refs.file.select()} />
                    </div>
                    <InputFile accept={'image/jpeg,image/png'}
                        ref='file'
                        onSelect={::this.handleChooseFile}
                               onCancelSelection={::this.handleCancelFile}/>
                    <TimeWithTimezoneLabel className={formStyles.timeLabel}
                        timezone={_.get(fieldValues.timezone, 'name', '')} />
                </div>
                <FormTextField fieldKey='email'
                    type='text'
                    label={loc('email-label')}
                    placeholder={loc('email-placeholder')} />

                <FormTextField fieldKey='password'
                    type='password'
                    label={loc('password-label')}
                    placeholder={loc('password-placeholder')} />

                <FormTextField fieldKey='confirmPassword'
                    type='password'
                    label={loc('confirm-password-label')}
                    placeholder={loc('confirm-password-placeholder')} />

                <FormFieldWrapper type='FormFieldWrapper' className={styles.twoColRow}>
                    <FormTextField fieldKey='firstName'
                        type='text'
                        label={loc('firstName-label')}
                        placeholder={loc('firstName-placeholder')} />

                    <FormTextField fieldKey='lastName'
                        type='text'
                        label={loc('lastName-label')}
                        placeholder={loc('lastName-placeholder')} />
                </FormFieldWrapper>
                <FormTextField fieldKey='middleName'
                    type='text'
                    label={loc('middleName-label')}
                    placeholder={loc('middleName-placeholder')} />
                <FormFieldWrapper type='FormFieldWrapper' className={styles.twoColRow}>
                    <GenderDropDownList fieldKey='gender'
                        canBeNotSelected
                        value={fieldValues.gender}
                        onChange={this.handleDropdownChanged.bind(this, 'gender')} />

                    <FormDatePicker
                        fieldKey='birthDate'
                        label={loc('birthDate-label')}
                        placeholder={'DD-MM-YYYY'}
                        inputVariant="filled"
                        variant="inline"
                        maxDate={moment()}
                        format='MM-DD-YYYY'
                        onChange={::this.handleChangeBirthDate}
                    />
                </FormFieldWrapper>

                <TimezoneDropDownList fieldKey='timezone'
                    value={fieldValues.timezone}
                    onChange={this.handleDropdownChanged.bind(this, 'timezone')} />

                <FormPhoneNumber fieldKey='phoneNumber'
                    type='tel'
                    label={loc('phoneNumber-label')}
                    placeholder={loc('phoneNumber-placeholder')} />

                <FormFieldWrapper type='FormFieldWrapper'><FormCheckbox
                    fieldKey='acceptTerms'
                    checked={acceptTerms}
                    onChange={onFieldChange}
                    checkboxLabel={
                        <span>
                            {loc('accept-terms')}
                            (<a
                                href='/terms-and-conditions'
                                target='_blank'
                                className={styles.link}
                            >
                                {loc('click-to-view-terms')}
                            </a>)
                        </span>
                    }
                /></FormFieldWrapper>
                <FormFieldWrapper type='FormFieldWrapper'>
                    <FormCheckbox
                        fieldKey='acceptPrivacyPolicy'
                        checked={acceptPrivacyPolicy}
                        onChange={onFieldChange}
                        checkboxLabel={
                            <span>
                                {loc('acknowledge-privacy')}
                                (<a
                                    href='/privacy-policy'
                                    target='_blank'
                                    className={styles.link}
                                >
                                    {loc('click-to-view-policy')}
                                </a>)
                        </span>
                        }
                    />
                </FormFieldWrapper>
                <FormFieldWrapper type='FormFieldWrapper'>
                    <FormCheckbox
                        fieldKey='acceptPrescriptionPolicy'
                        checked={acceptPrescriptionPolicy}
                        onChange={onFieldChange}
                        checkboxLabel={
                            <span>
                                {loc('acknowledge-prescription-policy')}
                                (<a
                                    href='/prescription-policy'
                                    target='_blank'
                                    className={styles.link}
                                >
                                    {loc('click-to-view-prescription-policy')}
                                </a>)
                        </span>
                        }
                    />
                </FormFieldWrapper>

                <ErrorMessage type='commonErrors' />
                <Button type='submit'
                    label={loc('sign-up-label')}
                    className={formStyles.submitButton}
                />
            </Form>
        );
    }

    formatPlain = value => {
        if (!value)
            return loc('choose');

        return value;
    };


    handleDropdownChanged(name, value) {
        const {onFieldChange} = this.props;
        onFieldChange(name, value);
    }

    handleDeleteTag(value, field) {
        const {onFieldChange, fieldValues} = this.props;
        const newValues = fieldValues[field].filter(v => v !== value);
        onFieldChange(field, {target: {value: newValues}});
    }

    handleChooseFile(file) {
        const rd = new FileReader();
        rd.onload = e => {
            this.setState({avatar: e.target.result});
        };
        rd.readAsDataURL(file);
        const {onFieldChange} = this.props;
        onFieldChange('avatar', {target: {value: file}});
    }

    handleCancelFile() {
        this.setState({avatar: null});
        const {onFieldChange} = this.props;
        onFieldChange('avatar', {target: {value: null}});
    }

    handleChangeBirthDate(date) {
        const {onFieldChange} = this.props;
        onFieldChange('birthDate', {target: {value: date}});
    }
}



// WEBPACK FOOTER //
// ./src/components/Auth/Register/PatientRegistrationForm.js